<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>회원 공간</p></li>
            <li><p>회원 홍보관</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>회원 홍보관</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="form_table">
            <div class="form">
              <ul class="form_ul">
                <li class="form_li">
                  <div class="form_ttl">
                    <p>제목</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="제목을 입력해 주세요"
                        v-model="form.boardTitle"
                      />
                      <p
                        class="valid"
                        :class="{ on: $v.form.boardTitle.$error }"
                      >
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p>내용</p>
                  </div>
                  <div class="form_in">
                    <div class="board_write">
                      <textarea
                        placeholder="내용을 입력해 주세요"
                        v-model="form.contents"
                      ></textarea>
                      <p class="valid" :class="{ on: $v.form.contents.$error }">
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">홍보 업체</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="업체명을 입력해 주세요."
                        v-model="form.company"
                      />
                      <p class="valid" :class="{ on: $v.form.company.$error }">
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">전화 번호</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="연락처를 입력해 주세요."
                        v-model="form.phone"
                      />
                      <p class="valid" :class="{ on: $v.form.phone.$error }">
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">대표자 명</p>
                  </div>
                  <div class="form_in">
                    <div class="input">
                      <input
                        type="text"
                        placeholder="대표자 명을 입력해 주세요."
                        v-model="form.representative"
                      />
                      <p
                        class="valid"
                        :class="{ on: $v.form.representative.$error }"
                      >
                        필수항목입니다.
                      </p>
                      <!--'on 추가'-->
                    </div>
                  </div>
                </li>
                <li class="form_li">
                  <div class="form_ttl">
                    <p class="essen">파일 업로드</p>
                  </div>
                  <div class="form_in">
                    <div class="inline">
                      <div class="input">
                        <input
                          type="text"
                          placeholder="소개파일을 업로드"
                          v-model="fileNames"
                          readonly
                        />
                        <input
                          ref="fileEl"
                          type="file"
                          style="display: none"
                          multiple
                          @change="fnFileChange"
                          @click="() => (form.files = [])"
                        />
                        <p class="valid" :class="{ on: $v.form.files.$error }">
                          필수항목입니다.
                        </p>
                      </div>
                      <button
                        class="btn bo"
                        @click="() => $refs['fileEl'].click()"
                      >
                        파일 선택
                      </button>
                    </div>
                    <p class="valid">필수항목입니다.</p>
                    <!--'on 추가'-->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn" @click="fnSave">글쓰기</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'space-promotion-write-index',
  data: function() {
    return {
      form: {
        boardTitle: '',
        contents: '',
        company: '',
        phone: '',
        representative: '',
        files: []
      }
    }
  },
  computed: {
    fileNames: function() {
      const array = Array.from(this.form.files)
      if (array.length < 2) {
        return array.map(item => {
          return item.name
        })
      } else {
        return `${array[0].name} 외 ${array.length - 1}개`
      }
    }
  },
  validations: {
    form: {
      boardTitle: { required },
      contents: { required },
      company: { required },
      phone: { required },
      representative: { required },
      files: { required }
    }
  },
  methods: {
    fnSave: async function() {
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }
      if (!confirm('글을 등록하시겠습니까?')) return
      const params = this.$_.cloneDeep(this.form)
      const files = []
      for (const file of params.files) {
        const res = await this.$CommonSvc.uploadFile({ file })
        files.push(res.entity)
      }
      params.fileBeans = files
      const res = await this.$SpaceSvc.postIntPromotion(params)
      if (res.code === 1) {
        this.$router.go(-1)
      } else {
        alert(res.message)
      }
    },
    fnFileChange: function(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.form.files = files
    }
  }
}
</script>

<style scoped></style>
